module.exports = __webpack_public_path__ + "img/40bb478.png";